import { Controller } from "@hotwired/stimulus"

// Чат-рыба: локальное добавление исходящего сообщения (без бэкенда).
export default class extends Controller {
  static targets = ["feed", "draft"]

  send() {
    const t = this.draftTarget.value.trim()
    if (!t) return
    const now = new Date()
    const time = `${now.getHours()}:${String(now.getMinutes()).padStart(2, "0")}`
    const row = document.createElement("div")
    row.style.cssText = "display:flex;justify-content:flex-end;"
    row.innerHTML = `<div style="position:relative;max-width:78%;padding:9px 13px 18px;border-radius:13px 13px 4px 13px;background:#128ddb;color:#fff;font-size:14px;line-height:1.4;box-shadow:0 2px 6px rgba(18,141,219,.2);"></div>`
    const bubble = row.firstChild
    bubble.appendChild(document.createTextNode(t))
    const ts = document.createElement("span")
    ts.style.cssText = "position:absolute;right:11px;bottom:5px;font-size:10px;font-weight:500;color:rgba(255,255,255,.75);"
    ts.textContent = time
    bubble.appendChild(ts)
    this.feedTarget.appendChild(row)
    this.draftTarget.value = ""
    this.feedTarget.scrollTop = this.feedTarget.scrollHeight
  }
}
